// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hX4o","title":"styles_title__2_eX8"};